import { RowDataTransaction } from "../../components/TransactionPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the TransactionTable factory
 */
class AllTransactionRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/transaction-all/read-transaction-history-range"
        this.accessData = "history"
    }

    create(transaction: any): RowDataTransaction {
        const rowDataTransaction: RowDataTransaction = {
            transaction_id: transaction.transaction_id,
            fullname: transaction.fullname,
            coins: transaction.coins ?? "",
            cash: transaction.cash ?? "",
            type: transaction.type,
            remark: "",
            created_at: transaction.createdAt,
        };
        return rowDataTransaction;
    }
}

let allTransactionRow: AllTransactionRow | null = null;

export default function getAllTransactionRow(): AllTransactionRow {
    if (allTransactionRow === null)
        allTransactionRow = new AllTransactionRow()
    return allTransactionRow
}